import ServiceCategoryPage from "../components/ServiceCategoryPage";
import labourService from "../data/services/labourService";

function Labour() {
  return <ServiceCategoryPage service={labourService} />;
}

export default Labour;